export const stats = [
  { value: '9', label: 'Volumes Complets' },
  { value: '600+', label: 'Pages de Ressources' },
  { value: '300+', label: 'Unités Didactiques' },
  { value: '100%', label: 'Prêt pour la Classe' },
]

export const beforeItems = [
  "Passer vos dimanches à planifier chaque leçon de géométrie ou d'algèbre.",
  'Chercher des fiches sur Pinterest qui ne respectent pas le programme officiel.',
  "Aucune progression claire : vos élèves oublient les bases d'un mois à l'autre.",
  'Devoir créer vous-même les évaluations et chercher les solutions.',
  "Se sentir frustré parce que la préparation vous enlève le plaisir d'enseigner.",
]

export const afterItems = [
  'Une année entière cartographiée et organisée pour chaque niveau (CP-3ème).',
  "Leçons, exercices et fiches de manipulation prêts à l'impression.",
  'Un curriculum en spirale logique pour ancrer les concepts durablement.',
  "Un enseignement simple pas à pas, du concret à l'abstrait.",
  'Évaluations intégrées et corrigés inclus pour économiser des semaines de travail.',
]

export const recognizeItems = [
  "Vous n'avez plus de temps pour planifier des leçons de mathématiques vraiment engageantes.",
  'Vous voyez les élèves décrocher dès que les concepts deviennent abstraits.',
  'Gérer des niveaux hétérogènes dans la même classe vous semble épuisant.',
  "Vous redoutez d'enseigner certaines notions par peur de ne pas être assez clair.",
]

export type Volume = {
  number: number
  level: string
  title: string
  text: string
}

export const primaryVolumes: Volume[] = [
  {
    number: 1,
    level: 'CP',
    title: 'L’Éveil des Nombres',
    text: 'Construire le sens du nombre et les premières additions.',
  },
  {
    number: 2,
    level: 'CE1',
    title: 'Le Voyage du Calcul',
    text: 'Automatisation, soustraction posée et géométrie de base.',
  },
  {
    number: 3,
    level: 'CE2',
    title: 'L’Exploration des Structures',
    text: 'Nombres jusqu’à 10 000 et initiation à la division.',
  },
  {
    number: 4,
    level: 'CM1',
    title: 'Les Maîtres des Fractions',
    text: 'Fractions équivalentes, décimaux et division posée.',
  },
  {
    number: 5,
    level: 'CM2',
    title: 'La Logique en Action',
    text: 'Pourcentages, aires et préparation au collège.',
  },
]

export const secondaryVolumes: Volume[] = [
  {
    number: 6,
    level: '6ème',
    title: 'Les Fondations du Raisonnement',
    text: 'Formalisation, algèbre de base et gestion des priorités.',
  },
  {
    number: 7,
    level: '5ème',
    title: 'L’Univers de l’Algèbre',
    text: 'Nombres relatifs, calcul littéral et théorème de Pythagore.',
  },
  {
    number: 8,
    level: '4ème',
    title: 'Les Lois de la Géométrie',
    text: 'Thalès, trigonométrie et fonctions affines.',
  },
  {
    number: 9,
    level: '3ème',
    title: 'Cap sur le Brevet',
    text: 'Inéquations, probabilités et préparation intensive au DNB.',
  },
]

export const bonuses = [
  {
    title: 'Kit « Rentrée Sereine »',
    text: 'Planifiez vos 36 semaines en 5 minutes et abordez l’année sans aucun stress de calendrier.',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/3a6ecf0d-ed2b-4824-8d9c-4a56473ca8ff.jpg',
  },
  {
    title: 'L’Arsenal des Évaluations',
    text: '81 tests complets avec corrigés « flash » pour évaluer sans passer vos nuits à corriger.',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/185b6f01-5bbe-4999-a4cc-dc6e630b1975.jpg',
  },
  {
    title: 'Le Coffre « Mathématiques en Vie »',
    text: '50 activités concrètes pour relier les mathématiques au monde réel (recettes, tickets de caisse, voyages).',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/b4c2e7bc-2f58-4b68-809d-e28a04d9e398.jpg',
  },
  {
    title: 'Le Laboratoire du Calcul Mental',
    text: 'Le système pour automatiser les réflexes de vos élèves et libérer leur mémoire de travail.',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/1fefe666-4808-4675-917d-d5297daeefd5.jpg',
  },
  {
    title: 'Boîte à Outils du Professeur Épanoui',
    text: 'Stratégies de productivité et de gestion de classe pour enseigner avec joie et énergie.',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/c180b292-c7b2-4dd7-a385-0c7a170e0f50.jpg',
  },
]

export const offerRows = [
  { label: 'Pack Mathématiques Prêtes (9 Volumes)', value: '197€' },
  { label: '5 Bonus Stratégiques', value: '185€' },
]

export const testimonials = [
  {
    quote:
      "C'est exactement ce dont j'avais besoin. La progression annuelle à elle seule vaut le prix. J'ai enfin récupéré mes dimanches et mes élèves de CM1 adorent les fiches visuelles.",
    name: 'Claire R.',
    role: 'Enseignante en Primaire',
  },
  {
    quote:
      "Le matériel est d'une qualité rare. Les élèves de 3ème accrochent enfin à la géométrie et je gagne un temps fou sur les corrections du Brevet.",
    name: 'Julien D.',
    role: 'Professeur de Mathématiques',
  },
]

export const faqs = [
  {
    q: 'Dans quel format sont les documents ?',
    a: "Tous les volumes sont au format PDF haute résolution, faciles à lire sur n'importe quel appareil et parfaits pour l'impression.",
  },
  {
    q: 'Est-ce adapté au nouveau programme ?',
    a: 'Oui, Mathématiques Prêtes™ est entièrement aligné sur les dernières directives du B.O. 2024.',
  },
  {
    q: 'Comment vais-je recevoir le matériel ?',
    a: "Immédiatement après votre paiement, vous recevrez un lien de téléchargement par e-mail pour accéder à l'intégralité du pack.",
  },
]

export const heroGuarantees = [
  'Téléchargement numérique instantané',
  "PDF prêts pour l'impression",
  'Paiement unique',
]

export const footerLinks = [
  'Conditions Générales',
  'Politique de Confidentialité',
  'Contact',
]
